import React from 'react';
import { useNivelAcesso } from '../hooks/useNivelAcesso';
import { useTheme } from '../contexts/ThemeContext';

const ProtectedByLevel = ({ 
  children, 
  niveisPermitidos = [], 
  fallback = null,
  showMessage = true 
}) => {
  const { user, hasNivelAcesso, getNivelLabel } = useNivelAcesso();
  const { darkMode } = useTheme();

  if (!user) {
    return fallback || (showMessage ? (
      <div className={`text-center p-4 ${
        'text-dim'
      }`}>
        Você precisa estar logado para acessar esta funcionalidade.
      </div>
    ) : null);
  }

  if (!hasNivelAcesso(niveisPermitidos)) {
    return fallback || (showMessage ? (
      <div className={`text-center p-4 ${
        'text-risk'
      }`}>
        Você não tem permissão para acessar esta funcionalidade.
        <br />
        <small>Nível necessário: {niveisPermitidos.map(n => getNivelLabel(n)).join(' ou ')}</small>
      </div>
    ) : null);
  }

  return children;
};

export default ProtectedByLevel;